// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2dmUM","emojiWrapper":"emojiWrapper__ZJj01","emoji":"emoji__Su6vK","hidden":"hidden__wwVVJ"};


//////////////////
// WEBPACK FOOTER
// ./components/EmojiGraph/style.css
// module id = yE6s
// module chunks = 0